"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNeedQualifReportRefusalEventContent = exports.findActiveNeedQualifReportScopeMatch = exports.NEED_QUALIF_REPORT_ZONE_RADIUS_KM = exports.isNeedQualifReportRefusalActive = exports.floorToHour = exports.computeNeedQualifReportRefusalEndDate = exports.isNeedQualifReportRefusalBlockingReason = exports.NEED_QUALIF_REPORT_REFUSAL_FOREVER_END_DATE = exports.NEED_QUALIF_REPORT_REFUSAL_DURATIONS = exports.NEED_QUALIF_REPORT_REFUSAL_BLOCKING_REASONS = exports.NEED_QUALIF_REPORT_APPLICATION_CLOSURE_DURATION = exports.NEED_QUALIF_REPORT_WORKER_DECLINED_DURATION = exports.NEED_QUALIF_REPORT_REFUSAL_REASONS = exports.NEED_QUALIF_REPORT_REFUSAL_REASONS_FOR_BACKOFFICE = exports.MAX_QUALIF_REPORTS_PER_BULK_ACTION = exports.NeedQualifReportReferrer = exports.NEED_QUALIF_REPORT_STATUSES_WITH_NOT_QUALIFIED = exports.NON_REFUSED_QUALIF_REPORT_STATUSES = exports.NEED_QUALIF_REPORT_STATUSES = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
const geo_logic_1 = require("../../utils/geo.logic");
exports.NEED_QUALIF_REPORT_STATUSES = (0, lib_custom_types_1.strictUnionArray)()([
    'RECOMMENDED',
    'REFUSED',
    'PRESELECTED',
    'PRESELECTED_INTERESTED',
    'TO_CALL',
]);
exports.NON_REFUSED_QUALIF_REPORT_STATUSES = (0, lib_custom_types_1.strictUnionArray)()([
    'RECOMMENDED',
    'PRESELECTED',
    'PRESELECTED_INTERESTED',
    'TO_CALL',
]);
exports.NEED_QUALIF_REPORT_STATUSES_WITH_NOT_QUALIFIED = (0, lib_custom_types_1.strictUnionArray)()([...exports.NEED_QUALIF_REPORT_STATUSES, 'NOT_QUALIFIED']);
exports.NeedQualifReportReferrer = {
    EmailRecommendation: 'EmailRecommendation',
    PrequalificationAuto: 'PrequalificationAuto',
    LegacyQualifPageNeedsModalButton: 'LegacyQualifPage.NeedsModalButton',
    NeedQualifPageActionsBarButton: 'NeedQualifPage.ActionsBar.Button',
    NeedQualifPageActionsBarDropdown: 'NeedQualifPage.ActionsBar.Dropdown',
    NeedQualifPageActionsBarNeedsModalButton: 'NeedQualifPage.ActionsBar.NeedsModalButton',
    NeedConsoleActionsBarButton: 'NeedConsole.ActionsBar.Button',
    NeedConsoleActionsBarMassDropdown: 'NeedConsole.ActionsBar.MassDropdown',
    NeedConsoleActionsBarNeedsModalButton: 'NeedConsole.ActionsBar.NeedsModalButton',
    NeedConsoleCVPreviewButton: 'NeedConsole.CVPreview.Button',
    NeedConsoleCVPreviewMassDropdown: 'NeedConsole.CVPreview.MassDropdown',
    NeedConsoleCVPreviewNeedsModalButton: 'NeedConsole.CVPreview.NeedsModalButton',
    CrossNeedsViewCVPreviewButton: 'CrossNeedsView.CVPreview.Button',
    CrossNeedsViewCVPreviewMassDropdown: 'CrossNeedsView.CVPreview.MassDropdown',
    CrossNeedsViewCVPreviewNeedsModalButton: 'CrossNeedsView.CVPreview.NeedsModalButton',
    NeedConsoleGlobalWorkerSearchQualifReportStatusSelect: 'NeedConsole.GlobalWorkerSearch.QualifReportStatusSelect',
    ApplicationsConsoleWorkersListHeaderNeedsModalButton: 'ApplicationsConsole.WorkersListHeader.NeedsModalButton',
    ApplicationsConsoleWorkerPanelApplicationsTab: 'ApplicationsConsole.WorkerPanel.ApplicationsTab',
    ApplicationsConsoleWorkerPanelNeedsTab: 'ApplicationsConsole.WorkerPanel.NeedsTab',
    ShiftListByCVActionsDropdownNeedsModalButton: 'ShiftListByCV.ActionsDropdown.NeedsModalButton',
    StaffingConsoleWorkerPanelApplicationsTab: 'StaffingConsole.WorkerPanel.ApplicationsTab',
    StaffingConsoleWorkerPanelNeedsTab: 'StaffingConsole.WorkerPanel.NeedsTab',
    WorkerProfileActionsBarNeedsModalButton: 'WorkerProfile.ActionsBar.NeedsModalButton',
    WorkerProfileHistoryApplicationClosure: 'WorkerProfile.History.ApplicationClosure',
    WorkerOldProfileActionsBarNeedsModalButton: 'WorkerOldProfile.ActionsBar.NeedsModalButton',
};
exports.MAX_QUALIF_REPORTS_PER_BULK_ACTION = 1000;
exports.NEED_QUALIF_REPORT_REFUSAL_REASONS_FOR_BACKOFFICE = (0, lib_custom_types_1.strictUnionArray)()([
    'NEED',
    'NEED_TEMPORARY',
    'ZONE',
    'JOB',
    'CLIENT',
    'SQUAD',
    'UNAVAILABLE',
]);
exports.NEED_QUALIF_REPORT_REFUSAL_REASONS = (0, lib_custom_types_1.strictUnionArray)()([
    ...exports.NEED_QUALIF_REPORT_REFUSAL_REASONS_FOR_BACKOFFICE,
    'WORKER_DECLINED',
]);
exports.NEED_QUALIF_REPORT_WORKER_DECLINED_DURATION = 'MONTH_1';
exports.NEED_QUALIF_REPORT_APPLICATION_CLOSURE_DURATION = 'MONTHS_3';
exports.NEED_QUALIF_REPORT_REFUSAL_BLOCKING_REASONS = (0, lib_custom_types_1.strictUnionArray)()([
    'ZONE',
    'JOB',
    'CLIENT',
    'SQUAD',
]);
exports.NEED_QUALIF_REPORT_REFUSAL_DURATIONS = (0, lib_custom_types_1.strictUnionArray)()([
    'MONTH_1',
    'MONTHS_3',
    'MONTHS_6',
    'YEAR_1',
    'FOREVER',
]);
exports.NEED_QUALIF_REPORT_REFUSAL_FOREVER_END_DATE = new Date('9999-12-31T23:59:59.999Z');
const NEED_QUALIF_REPORT_REFUSAL_DURATION_MONTHS = {
    MONTH_1: 1,
    MONTHS_3: 3,
    MONTHS_6: 6,
    YEAR_1: 12,
};
const isNeedQualifReportRefusalBlockingReason = (reason) => exports.NEED_QUALIF_REPORT_REFUSAL_BLOCKING_REASONS.includes(reason);
exports.isNeedQualifReportRefusalBlockingReason = isNeedQualifReportRefusalBlockingReason;
const addMonthsUtc = (date, months) => {
    const result = new Date(date.getTime());
    const day = result.getUTCDate();
    result.setUTCDate(1);
    result.setUTCMonth(result.getUTCMonth() + months);
    const lastDayOfTargetMonth = new Date(Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0)).getUTCDate();
    result.setUTCDate(Math.min(day, lastDayOfTargetMonth));
    return result;
};
const computeNeedQualifReportRefusalEndDate = (duration, from) => duration === 'FOREVER'
    ? exports.NEED_QUALIF_REPORT_REFUSAL_FOREVER_END_DATE
    : addMonthsUtc(from, NEED_QUALIF_REPORT_REFUSAL_DURATION_MONTHS[duration]);
exports.computeNeedQualifReportRefusalEndDate = computeNeedQualifReportRefusalEndDate;
const floorToHour = (date) => {
    const floored = new Date(date);
    floored.setMinutes(0, 0, 0);
    return floored;
};
exports.floorToHour = floorToHour;
const isNeedQualifReportRefusalActive = (refusal, now) => !refusal?.endDate || new Date(refusal.endDate) >= (0, exports.floorToHour)(now);
exports.isNeedQualifReportRefusalActive = isNeedQualifReportRefusalActive;
exports.NEED_QUALIF_REPORT_ZONE_RADIUS_KM = 5;
const toGeoPoint = (geoPoint) => {
    if (!geoPoint) {
        return undefined;
    }
    if (!Array.isArray(geoPoint)) {
        return geoPoint;
    }
    const [lon, lat] = geoPoint;
    return geoPoint.length === 2 && lon != null && lat != null ? { lat, lon } : undefined;
};
const noScopeMatchForUnknownReason = (reason) => false;
const doesNeedQualifReportScopeMatch = (snapshot, { squadId, companyIds = [], jobIds = [], coordinates }, nowFlooredToHour) => {
    if (!squadId || snapshot.squadId !== squadId || !snapshot.endDate) {
        return false;
    }
    if (new Date(snapshot.endDate) < nowFlooredToHour) {
        return false;
    }
    if (!snapshot.reason || !(0, exports.isNeedQualifReportRefusalBlockingReason)(snapshot.reason)) {
        return false;
    }
    switch (snapshot.reason) {
        case 'SQUAD':
            return true;
        case 'CLIENT':
            return !!snapshot.clientId && companyIds.includes(snapshot.clientId);
        case 'JOB':
            return !!snapshot.jobId && jobIds.includes(snapshot.jobId);
        case 'ZONE': {
            const pin = toGeoPoint(snapshot.geoPoint);
            return !!coordinates && !!pin && (0, geo_logic_1.haversineDistanceKm)(coordinates, pin) <= exports.NEED_QUALIF_REPORT_ZONE_RADIUS_KM;
        }
        default:
            return noScopeMatchForUnknownReason(snapshot.reason);
    }
};
const findActiveNeedQualifReportScopeMatch = (snapshots, context, now) => {
    const nowFlooredToHour = (0, exports.floorToHour)(now);
    const matches = (snapshot) => doesNeedQualifReportScopeMatch(snapshot, context, nowFlooredToHour);
    return (snapshots ?? [])
        .filter(matches)
        .reduce((longestLived, snapshot) => !longestLived || new Date(snapshot.endDate) > new Date(longestLived.endDate) ? snapshot : longestLived, undefined);
};
exports.findActiveNeedQualifReportScopeMatch = findActiveNeedQualifReportScopeMatch;
const toRefusalScopeEventContent = (refusal) => {
    const noScope = { squadId: null, clientId: null, jobId: null, geoPoint: null };
    switch (refusal.reason) {
        case 'SQUAD':
            return { ...noScope, squadId: refusal.squadId ?? null };
        case 'CLIENT':
            return { ...noScope, squadId: refusal.squadId ?? null, clientId: refusal.clientId ?? null };
        case 'JOB':
            return { ...noScope, squadId: refusal.squadId ?? null, jobId: refusal.jobId ?? null };
        case 'ZONE':
            return {
                ...noScope,
                squadId: refusal.squadId ?? null,
                geoPoint: refusal.geoPoint ? { lat: refusal.geoPoint.lat, lon: refusal.geoPoint.lon } : null,
            };
        default:
            return noScope;
    }
};
const toNeedQualifReportRefusalEventContent = (refusal) => {
    if (!refusal) {
        return null;
    }
    return {
        reason: refusal.reason,
        endDate: refusal.endDate ?? null,
        ...toRefusalScopeEventContent(refusal),
    };
};
exports.toNeedQualifReportRefusalEventContent = toNeedQualifReportRefusalEventContent;
